// returns how many pixels the user has scrolled vertically
export default function getScrollTop() {
  return (window.pageYOffset !== undefined) ?
    window.pageYOffset :
    (document.documentElement || document.body.parentNode || document.body).scrollTop;
}



// WEBPACK FOOTER //
// ./src/util/getScrollTop.js